<div *ngIf="selectedProgramType !== 'Alumni'" class="w-full  flex flex-column border-1 border-300 border-round-lg align-items-center">
    <div class="w-full flex-column p-4 flex gap-3">
        <h2 class="text-left font-medium text-xl" style="color: #000086;">Rankings</h2>
        <div class="grid align-items-start">

            <div *ngIf="selectedProgramType === 'Bachelor\'s Degree'" class="col-12 sm:col-4 flex flex-column gap-1">
                <p class="font-medium text-base font-semibold text-bluegray-600">NIRF Ranking</p>
                <b class="font-semibold text-xl">#{{institute?.nirfRanking}}</b>
            </div>
            <div *ngIf="institute?.indiaTodayRanking" class="col-12 sm:col-4 flex flex-column gap-1">
                <p class="font-medium text-base font-semibold text-bluegray-600">India Today Ranking</p>
                <b class="font-semibold text-xl">#{{institute?.indiaTodayRanking}}</b>
            </div>
            <div *ngIf="institute?.subjectRanks && (institute?.subjectRanks | keyvalue)?.length"
                class="col-12 sm:col-4 flex flex-column gap-1 ">
                <p class="font-medium text-base font-semibold text-bluegray-600">Subject Ranks</p>
                <div class="font-semibold text-xl" *ngFor="let subjectRank of institute?.subjectRanks | keyvalue">
                    {{subjectRank.key}}: {{subjectRank.value}}</div>
            </div>
        </div>
    </div>
</div>

<div *ngIf="selectedProgramType !== 'Alumni'" id="divFacilities" class="w-full mt-3 flex flex-column border-1 border-300 border-round-lg p-4 gap-3">
    <h2 class="text-left font-medium text-xl m-0" style="color: #000086;">Facilities</h2>
    <div *ngIf="institute?.facilities?.sportsFacilities || institute?.facilities?.swimmingPool || institute?.facilities?.gym; else noFacilities" 
         class="flex flex-wrap gap-5">
        
        <div *ngIf="institute?.facilities?.sportsFacilities" class="flex flex-column align-items-center gap-2">
            <div class="flex align-items-center justify-content-center border-circle shadow-1" style="width: 3.5rem; height: 3.5rem; background-color: #000086;">
                <i class="pi pi-trophy text-white text-xl"></i>
            </div>
            <div class="text-center">
                <p class="font-bold m-0" style="color: #12263F;">Sports Facilities</p>
                <p class="text-sm text-bluegray-400 m-0">Available</p>
            </div>
        </div>

        <div *ngIf="institute?.facilities?.swimmingPool" class="flex flex-column align-items-center gap-2">
            <div class="flex align-items-center justify-content-center border-circle shadow-1" style="width: 3.5rem; height: 3.5rem; background-color: #000086;">
                <i class="pi pi-map text-white text-xl"></i>
            </div>
            <div class="text-center">
                <p class="font-bold m-0" style="color: #12263F;">Swimming Pool</p>
                <p class="text-sm text-bluegray-400 m-0">Available</p>
            </div>
        </div>

        <div *ngIf="institute?.facilities?.gym" class="flex flex-column align-items-center gap-2">
            <div class="flex align-items-center justify-content-center border-circle shadow-1" style="width: 3.5rem; height: 3.5rem; background-color: #000086;">
                <i class="pi pi-bolt text-white text-xl"></i>
            </div>
            <div class="text-center">
                <p class="font-bold m-0" style="color: #12263F;">Gym</p>
                <p class="text-sm text-bluegray-400 m-0">Available</p>
            </div>
        </div>

    </div>
    <ng-template #noFacilities>
        <div class="flex align-items-center gap-2 text-bluegray-400 py-2">
            <i class="pi pi-info-circle text-xl"></i>
            <span>No facilities information available.</span>
        </div>
    </ng-template>
</div>

<app-institute-detail-alumni
  *ngIf="selectedProgramType === 'Alumni'"
  [institute]="institute">
</app-institute-detail-alumni>

<!-- <div id="divAdmissions" class="w-full mt-3 flex flex-column border-1 border-300 border-round-lg align-items-center">
    <div class="w-full p-4 flex flex-column gap-3">
        <h2 class="text-left text-xl font-medium" style="color: #000086;">Admissions</h2>
        <div class="w-full flex justify-content-between">
            <div class="flex flex-column gap-1" *ngIf="isUGDetails(instituteUGMDetails)">
                <p class="text-base font-semibold text-bluegray-600">Eligibility requirements</p>
                <b class="text-2xl font-bold">N/A</b>
            </div>
            <div *ngIf="isUGDetails(instituteUGMDetails)" class="flex flex-column gap-1">
                <p class="text-base font-semibold text-bluegray-600">Application Deadline - Regular Decision</p>
                <b class="text-2xl font-bold">{{ instituteUGMDetails.applicationDeadlineRegularDecision ?? 'N/A'}}</b>
            </div>
        </div>
    </div>
</div> -->

<!-- <div id="divCost" class="w-full  mt-3  flex flex-column border-1 border-300 border-round-lg align-items-center">
    <div class="flex flex-column gap-3 w-full p-4">
    <h2 class="text-left text-xl font-medium" style="color: #000086;">Cost</h2>
    <div class="flex gap-6 flex-column md:flex-row">
        <div class="flex-1 flex flex-column gap-3">
        <div class="flex flex-column gap-3">

            <div *ngIf="isUGDetails(instituteUGMDetails)" class="flex flex-column gap-1">
                <p class="text-base font-semibold font-medium text-bluegray-600">Net Price</p>
                <b class="text-2xl font-bold">{{ getAmount(instituteUGMDetails.currency,
                    ( instituteUGMDetails.averageTutionFees ?? 0) || 0) }}</b>
            </div>
            <div *ngIf="isMastersDetails(instituteUGMDetails)" class="flex flex-column gap-1">
                <p class="text-base font-semibold font-medium text-bluegray-600">Net Price</p>
                <b class="text-2xl font-bold">{{ getAmount(instituteUGMDetails.currency,
                    instituteUGMDetails.tutionFees??0) }}</b>
            </div>
            <div class="flex flex-column">
            <div class="flex align-items-center justify-content-between border-top-1 border-300 py-3">
                <p class="text-base font-semibold text-bluegray-600">Avgerage living and other expenses</p>
                <p class="text-base font-semibold font-medium" style="color: #12263F;">{{ getAmount(instituteUGMDetails.currency,
                    ( instituteUGMDetails.combinedFoodAndHousingCharge ?? 0) || 0) }}
                </p>
            </div>
            <div class="flex align-items-center justify-content-between border-top-1 border-300 py-3">
                <p class="text-base font-semibold text-bluegray-600">Average rent in area</p>
                <p class="text-base font-semibold font-medium" style="color: #12263F;">N/A</p>
            </div>
            </div>
        </div>
        </div>
    </div>
    </div>
</div> -->
<!-- 
<div *ngIf="isUGDetails(instituteUGMDetails)" id="divScholarship" class="w-full  mt-3  flex flex-column border-1 border-300 border-round-lg align-items-center">
    <div class="flex flex-column gap-3 w-full p-4">
    <h2 class="text-left text-xl font-medium" style="color: #000086;">Scholarships</h2>
    
        <div  class="flex flex-column gap-1">
            <p class="text-base font-semibold font-medium text-bluegray-600">{{}}</p><br>
        </div>
    
    @for (item of instituteUGMDetails.findScholarships; track $index) {
        <div class="flex flex-column gap-2">
            <a href="#" class="w-full h-3rem px-3 border-round-lg font-medium text-base font-semibold link_scholarship " style="line-height: 48px; color: #101010;">{{item}}</a>
        </div>
    }
    </div>
</div> -->

<div *ngIf="selectedProgramType === 'Bachelor\'s Degree' && isUGDetails(instituteUGMDetails)" id="divScholarship"
    class="w-full mt-3  flex flex-column border-1 border-300 border-round-lg align-items-center">
    <div class="flex flex-column gap-3 w-full p-4">
        @if (scholarships.length > 0) {
        <h2 class="text-left text-xl font-medium" style="color: #000086;">Scholarships</h2>

        <!-- <div class="flex flex-column gap-1">
                <p class="text-base font-semibold font-medium text-bluegray-600">Graduate Schools within</p>
            </div> -->
        @for (item of visibleScholarships; track $index) {
        <div class="flex flex-column gap-2">
            <a class="w-full h-auto px-4 py-2 border-round-lg font-medium text-base font-semibold link_scholarship"
                style="color: #101010; white-space: normal; word-wrap: break-word; background-color: #d1c4e9;">
                {{ item }}
            </a>
        </div>
        }
        <div *ngIf="scholarships.length > 3" class="mt-2 flex justify-content-end">
            <button
                class=" text-base font-semibold border-none border-round cursor-pointer hover:underline text-blue-600 bg-transparent"
                (click)="toggleScholarshipsView()">
                {{ showAllScholarships ? 'Show Less' : 'View All Scholarships' }}
            </button>
        </div>
        }@else {
        <h2 class="text-left text-xl text-bluegray-600 font-medium" style="color: #000086;">Scholarships</h2>
        }
    </div>
</div>


<div *ngIf="selectedProgramType === 'Bachelor\'s Degree' || selectedProgramType === 'Master\'s Degree'" id="divStudents"
    class="w-full  mt-3 ">
    <div class="grid grid-nogutter border-1 border-300 border-round-lg p-4">
        <div class="md:col-6 col-12 flex flex-column gap-3">
            <h2 class="text-left text-xl font-medium" style="color: #000086;">Student & Enrollments</h2>
            <div class="flex flex-column">
                <div *ngIf="isUGDetails(instituteUGMDetails)" class="flex flex-column gap-1 pb-3">
                    <p class="text-base font-semibold text-bluegray-600">Total Enrollments</p>
                    <b class="text-2xl font-bold">{{instituteUGMDetails.totalEnrollmentInInstitution === '' ? 'N/A'
                        :instituteUGMDetails.totalEnrollmentInInstitution | number}} <span
                            class="text-base font-semibold text-bluegray-600">Grads</span></b>
                </div>
                <div *ngIf="isMastersDetails(instituteUGMDetails)" class="flex flex-column gap-1 pb-3">
                    <p class="text-base font-semibold text-bluegray-600">Graduate Enrollments</p>
                    <b class="text-2xl font-bold">{{instituteUGMDetails.graduateStudentsEnrolled === 0 ? 'N/A'
                        :instituteUGMDetails.graduateStudentsEnrolled | number}} <span
                            class="text-base font-semibold text-bluegray-600">Grads</span></b>
                </div>

                <div *ngIf="isUGDetails(instituteUGMDetails)"
                    class="flex align-items-center justify-content-between border-top-1 border-300 py-3">
                    <p class="text-base font-semibold text-bluegray-600">Fulltime Undergraduate Enrollment</p>
                    <p class="text-base font-semibold font-medium" style="color: #12263F;">
                        {{instituteUGMDetails.fullTimeEnrollment | number}}</p>
                </div>
                <div *ngIf="isUGDetails(instituteUGMDetails)"
                    class="flex align-items-center justify-content-between border-top-1 border-300 py-3">
                    <p class="text-base font-semibold text-bluegray-600">Male Undergraduate Enrollment</p>
                    <p class="text-base font-semibold font-medium" style="color: #12263F;">
                        {{instituteUGMDetails.fullTimeUndergraduateMaleEnrollment | number}}</p>
                </div>
                <div *ngIf="isUGDetails(instituteUGMDetails)"
                    class="flex align-items-center justify-content-between border-top-1 border-300 py-3">
                    <p class="text-base font-semibold text-bluegray-600">Female Undergraduate Enrollment</p>
                    <p class="text-base font-semibold font-medium" style="color: #12263F;">
                        {{instituteUGMDetails.fullTimeUndergraduateFemaleEnrollment | number}}</p>
                </div>
                <div *ngIf="isUGDetails(instituteUGMDetails)"
                    class="flex align-items-center justify-content-between border-top-1 border-300 py-3">
                    <p class="text-base font-semibold text-bluegray-600">Student Faculty Ratio</p>
                    <p class="text-base font-semibold font-medium" style="color: #12263F;">
                        {{instituteUGMDetails.studentFacultyRatio}}</p>
                </div>
                <div *ngIf="isMastersDetails(instituteUGMDetails)"
                    class="flex align-items-center justify-content-between border-top-1 border-300 py-3">
                    <p class="text-base font-semibold text-bluegray-600">Fulltime Graduate Enrollment</p>
                    <p class="text-base font-semibold font-medium" style="color: #12263F;">
                        {{instituteUGMDetails.graduateStudentsEnrolled | number}}</p>
                </div>
                <div *ngIf="isMastersDetails(instituteUGMDetails)"
                    class="flex align-items-center justify-content-between border-top-1 border-300 py-3">
                    <p class="text-base font-semibold text-bluegray-600">Male Graduate Enrollment</p>
                    <p class="text-base font-semibold font-medium" style="color: #12263F;">
                        {{ formatPercent(instituteUGMDetails.maleGraduateEnrollment) }}</p>
                </div>
                <div *ngIf="isMastersDetails(instituteUGMDetails)"
                    class="flex align-items-center justify-content-between border-top-1 border-300 py-3">
                    <p class="text-base font-semibold text-bluegray-600">Female Graduate Enrollment</p>
                    <p class="text-base font-semibold font-medium" style="color: #12263F;">
                       {{ formatPercent(instituteUGMDetails.femaleGraduateEnrollment) }}</p>
                </div>
                <!-- <div class="flex align-items-center justify-content-between border-top-1 border-300 py-3">
                <p class="text-base font-semibold text-bluegray-600">Undergraduate Students</p>
                <p class="text-base font-semibold font-medium" style="color: #12263F;">{{instituteUGMDetails.underGraduate}}</p>
            </div> -->
            </div>
        </div>
        <div *ngIf="isUGDetails(instituteUGMDetails)"
            class="md:col-6 col-12 pt-4 md:pt-0 flex flex-column align-items-center justify-content-center">
            @if(pieData){
            <p-chart #chart1 type="pie" type="pie" [data]="pieData" [options]="pieOptions" />
            }
        </div>
        <div *ngIf="isMastersDetails(instituteUGMDetails)"
            class="md:col-6 col-12 pt-4 md:pt-0 flex flex-column align-items-center justify-content-center">
            @if(pieData){
            <p-chart #chart1 type="pie" type="pie" [data]="pieData" [options]="pieOptions" />
            }
        </div>
    </div>
</div>

<div *ngIf="selectedProgramType === 'Bachelor\'s Degree' || selectedProgramType === 'Master\'s Degree'"
    id="divAcademics" class="w-full mt-3  flex flex-column border-1 border-300 border-round-lg align-items-center">
    <div class="flex flex-column gap-3 w-full p-4">
        <h2 class="text-left text-xl font-medium" style="color: #000086;">Academics</h2>
        <div class="w-full grid grid-nogutter align-items-center">
            <div class="col-12 md:col-6">
                <!-- <div *ngIf="isUGDetails(instituteUGMDetails)" class="flex align-items-center justify-content-between border-top-1 border-300 py-3">
                <p class="text-base font-semibold text-bluegray-600">Total no. of courses offered</p>
                <p class="text-base font-semibold font-medium" style="color: #12263F;">{{instituteUGMDetails.numberOfCoursesOffered}}</p>
            </div> -->
                <div class="flex align-items-center justify-content-between border-top-1 border-300 py-3">
                    <p class="text-base font-semibold text-bluegray-600">Total Departments</p>
                    <p class="text-base font-semibold font-medium" style="color: #12263F;">
                        {{instituteUGMDetails.totalDepartments ?? '0'}}</p>
                </div>
                <div class="flex align-items-center justify-content-between border-top-1 border-300 py-3">
                    <p class="text-base font-semibold text-bluegray-600">Faculty</p>
                    <p class="text-base font-semibold font-medium" style="color: #12263F;">{{instituteUGMDetails.faculty
                        ?? '0'}}</p>
                </div>
                <!-- <div class="flex align-items-center justify-content-between border-top-1 border-300 py-3">
                <p class="text-base font-semibold text-bluegray-600">STR</p>
                <p class="text-base font-semibold font-medium" style="color: #12263F;">N/A</p>
            </div> -->
                <!-- <div *ngIf="isMastersDetails(instituteUGMDetails)" class="flex align-items-center justify-content-between border-top-1 border-300 py-3">
                <p class="text-base font-semibold text-bluegray-600">Total no. of Phd courses offered</p>
                <p class="text-base font-semibold font-medium" style="color: #12263F;">{{instituteUGMDetails.numberOfCoursesOffersPhd}}</p>
            </div>
            <div *ngIf="isMastersDetails(instituteUGMDetails)" class="flex align-items-center justify-content-between border-top-1 border-300 py-3">
                <p class="text-base font-semibold text-bluegray-600">Total no. of Masters courses offered</p>
                <p class="text-base font-semibold font-medium" style="color: #12263F;">{{instituteUGMDetails.numberOfCoursesOffersMasters}}</p>
            </div> -->
            </div>
            <div class="col-12 md:col-6">
                <div class="flex flex-column gap-1 pt-4 md:pt-0 md:pl-4">
                    <a (click)="triggerDisplayCourses()" class="h-3rem flex-1 text-center border-round-lg link_aa"
                        style="line-height: 48px; color: #fff;">Find Undergraduate Courses</a>
                    <a (click)="triggerDisplayCourses()" class="h-3rem flex-1 text-center border-round-lg link_aay"
                        style="line-height: 48px; color: #101010;">Find Graduate Courses</a>
                </div>
            </div>
        </div>
    </div>
</div>

<!-- <div id="divMajors" class="w-full  mt-3 flex flex-column border-1 border-300 border-round-lg align-items-center">
    <div class="w-full p-4 flex flex-column gap-3">
    <h2 class="text-left text-xl font-medium" style="color: #000086;">Majors</h2>
    <div *ngIf="selectedProgramType === 'Bachelor\'s Degree'">
        <h1 class="text-left text-2xl font-bold">Most Popular Undergraduate Majors</h1>
        <div class="flex flex-column">
            @for (major of (instituteBachelorMajors || []).slice(0, 3); track major) {
            <div class="flex align-items-center justify-content-between border-bottom-1 border-300 py-3">
            <p class="text-base font-semibold text-bluegray-600">{{major.fieldOfStudy}}</p>
            <p class="text-base font-semibold font-medium" style="color: #12263F;">{{major.numberOfGraduates}} Graduates</p>
            </div>
            }
            <div class="flex align-items-center justify-content-between border-300 pt-3">
            <p-accordion class="w-full">
                <p-accordionTab header="More" iconPos="end" headerStyleClass="header_tab"
                contentStyleClass="tab_content">
                <div class="flex flex-column pt-3 ">
                @for (major of (instituteBachelorMajors || []).slice(3); track major) {
                    <div class="flex align-items-center justify-content-between border-bottom-1 border-300 py-3">
                    <p class="text-base font-semibold text-bluegray-600">{{major.fieldOfStudy}}</p>
                    <p class="text-base font-semibold font-medium" style="color: #12263F;">{{major.numberOfGraduates}} Graduates</p>
                    </div>
                }
                </div>
                </p-accordionTab>
            </p-accordion>
            </div>
        </div>
    </div>
    <div *ngIf="selectedProgramType === 'Master\'s Degree'">
        <h1 class="text-left text-2xl font-bold">Most Popular Postgraduate Majors</h1>
        <div class="flex flex-column">
            @for (major of (instituteGraduateMajors || []).slice(0, 3); track major) {
            <div class="flex align-items-center justify-content-between border-bottom-1 border-300 py-3">
            <p class="text-base font-semibold text-bluegray-600">{{major.fieldOfStudy}}</p>
            <p class="text-base font-semibold font-medium" style="color: #12263F;">{{major.numberOfGraduates}} Graduates</p>
            </div>
            }
            <div class="flex align-items-center justify-content-between border-300 pt-3">
            <p-accordion class="w-full">
                <p-accordionTab header="More" iconPos="end" headerStyleClass="header_tab"
                contentStyleClass="tab_content">
                <div class="flex flex-column pt-3 ">
                @for (major of (instituteGraduateMajors || []).slice(3); track major) {
                    <div class="flex align-items-center justify-content-between border-bottom-1 border-300 py-3">
                    <p class="text-base font-semibold text-bluegray-600">{{major.fieldOfStudy}}</p>
                    <p class="text-base font-semibold font-medium" style="color: #12263F;">{{major.numberOfGraduates}} Graduates</p>
                    </div>
                }
                </div>
                </p-accordionTab>
            </p-accordion>
            </div>
        </div>

        <h1 class="text-left text-2xl mt-1 font-bold">Most Popular Doctoral Majors</h1>
        <div class="flex flex-column">
            @for (major of (instituteDoctoralMajors || []).slice(0, 3); track major) {
            <div class="flex align-items-center justify-content-between border-bottom-1 border-300 py-3">
            <p class="text-base font-semibold text-bluegray-600">{{major.fieldOfStudy}}</p>
            <p class="text-base font-semibold font-medium" style="color: #12263F;">{{major.numberOfGraduates}} Graduates</p>
            </div>
            }
            <div class="flex align-items-center justify-content-between border-300 pt-3">
            <p-accordion class="w-full">
                <p-accordionTab header="More" iconPos="end" headerStyleClass="header_tab"
                contentStyleClass="tab_content">
                <div class="flex flex-column pt-3 ">
                @for (major of (instituteDoctoralMajors || []).slice(3); track major) {
                    <div class="flex align-items-center justify-content-between border-bottom-1 border-300 py-3">
                    <p class="text-base font-semibold text-bluegray-600">{{major.fieldOfStudy}}</p>
                    <p class="text-base font-semibold font-medium" style="color: #12263F;">{{major.numberOfGraduates}} Graduates</p>
                    </div>
                }
                </div>
                </p-accordionTab>
            </p-accordion>
            </div>
        </div>
    </div>

    </div>
</div> -->


<div *ngIf="selectedProgramType !== 'Alumni'" id="divAfterCollege" class="w-full mt-3  flex flex-column border-1 border-300 border-round-lg align-items-center">
    <div class="flex flex-column gap-3 w-full p-4">
        <h2 class="text-left text-xl font-medium" style="color: #000086;">After College</h2>
        <div class="grid grid-nogutter align-items-end">
            <!-- <div *ngIf="isUGDetails(instituteUGMDetails)" class="md:col-4 col-12">
            <div class="flex flex-column gap-1 pb-3 md:pb-0 md:pr-3">
                <p class="text-base font-semibold text-bluegray-600">Median Earnings after 1 year</p>
                <b class="text-2xl font-bold">{{ getAmount(instituteUGMDetails.currency,
                    ( instituteUGMDetails.medianEarningsOfGraduatesWorkingPostOneYearCompletion ?? 0) || 0) }} <span class="text-base font-semibold text-bluegray-600"> / per year</span></b>
            </div>
        </div> -->
            <div *ngIf="isUGDetails(instituteUGMDetails)" class="md:col-4 col-12">
                <div class="flex flex-column gap-1 pb-3 md:pb-0 md:pr-3">
                    <p class="text-base font-semibold text-bluegray-600">Median Earnings After Graduation </p>
                    <b class="text-xl font-bold">{{ getAmount(instituteUGMDetails.currency,
                        ( instituteUGMDetails.medianEarningsOfGraduatesWorkingPostFiveYearCompletion ?? 0) || 0) }}<span
                            class="text-base font-semibold text-bluegray-600"> / per year</span></b>
                </div>
            </div>
            <div class="md:col-8 col-12">
                <div class="flex flex-column gap-1 pb-3 md:pb-0 md:pr-3">
                    <p class="text-base font-semibold text-bluegray-600">Popular Employers</p>
                    <b class="text-xl font-bold">{{popularEmployers ? popularEmployers: 'N/A'}}</b>
                </div>
            </div>

            <!-- <div *ngIf="isUGDetails(instituteUGMDetails)" class="md:col-4 col-12">
            <div class="flex flex-column gap-1 pb-3 md:pb-0 md:pr-3">
                <p class="text-base font-semibold text-bluegray-600">Graduation rate for international students 2023 </p>
                <b class="text-2xl font-bold">{{instituteUGMDetails.internationalStudentsGraduationRate}}</b>
            </div>
        </div> -->
            <!-- <div *ngIf="isUGDetails(instituteUGMDetails)" class="md:col-4 col-12">
            <div class="flex flex-column gap-1 pb-3 md:pb-0 md:pr-3">
                <p class="text-base font-semibold text-bluegray-600">Graduation rate for total cohort </p>
                <b class="text-2xl font-bold">{{instituteUGMDetails.totalCohortGraduationRate}}</b>
            </div>
        </div> -->

            <!-- <div *ngIf="isUGDetails(instituteUGMDetails)" class="md:col-4 col-12">
            <div class="flex flex-column gap-1 pb-3 md:pb-0 md:pr-3">
                <p class="text-base font-semibold text-bluegray-600">Students earning more than a high school graduate (threshold earnings) 11 years after entry </p>
                <b class="text-2xl font-bold">{{instituteUGMDetails.percentEarningAboveHighSchool11Years}}</b>
            </div>
        </div> -->
            <div class="md:col-4 col-12 flex justify-content-end">
                <a [routerLink]="'/portal/peer'" class="h-3rem block flex-1 text-center border-round-lg link_aay"
                    style="line-height: 48px; color: #101010;">Connect with Alumni</a>
            </div>
        </div>
    </div>
</div>